export const NEXT_PATCH_SYMBOL = Symbol.for('next-patch')
